import { fieldTypes, WEEK_LABELS } from "@constants/constant";
import { Application } from "@enums/application.enums";
import { TableHeaderTypes } from "@enums/table.enum";
import { getCurrentDate } from "@utils/common.utils";

export const Messages = {
  BADGE: 'Badge',
  BADGE_STATUS: 'Status',
  PURCHASER: 'Purchaser',
  CONTENT_ENGAGER: 'Content Engager',
  IMPORTED_UNREGISTERED: 'Imported & Unregistered',
  // Section Headings
  PERSONAL_INFORMATION: 'Personal Information',
  ACTIVITY_SUMMARY: 'Activity Summary',
  // Accordion Section Titles
  DEMOGRAPHICS: 'Demographics',
  GENERAL_ACTIVITY: 'General Activity',
  PURCHASE_HISTORY: 'Purchase History',
  CONTENT_ENGAGEMENT: 'Content Engagement',
  TOPIC_ENGAGEMENT: 'Topic Engagement',
  // Accordion Info Messages
  DEMOGRAPHICS_INFO: 'Filter Fans by Their Age Range, Gender, Geographic Location and Radius.',
  GENERAL_ACTIVITY_INFO: 'Filter Fans by Their Fan Status with You, Engagement Recency and Frequency, and Spend Levels.',
  PURCHASE_HISTORY_INFO: 'Filter Fans by What Items, Services and Subscriptions They\'ve Purchased or Didn\'t Purchase from You. External Merchandise (Non-Shopify Items) and NFTs Are Not Tracked.',
  CONTENT_ENGAGEMENT_INFO: 'Filter Fans by What Content They Engaged with or Didn\'t Engage with, and during Which Time Period.',
  TOPIC_ENGAGEMENT_INFO: 'Filter Fans by What Topics They Engaged with or Didn\'t Engage with.',
  // Form Field Labels
  MIN_AGE: 'Min Age',
  MAX_AGE: 'Max Age',
  GENDER: 'Gender',
  POST_ENGAGEMENT_START_DATE: 'Post Engagement Start Date*',
  POST_ENGAGEMENT_END_DATE: 'Post Engagement End Date*',
  FILTER_NAME: 'Filter Name *',
  // Placeholders
  SELECT_GENDER: 'Select Gender',
  SELECT_PURCHASE: 'Select Purchase',
  SELECT_CONTENT_ITEM: 'Select Content Item',
  SELECT_TOPIC: 'Select Topic',
  ANYTIME: 'Anytime',
  EXTERNAL_PARTIES_COST:
    'Note: TopFan only charges you the costs from external 3rd parties to provide this service',
  COST_TO_SEND_EMAIL_PER_USER: 'Cost to Send Email per user',
  TOTAL_COST: 'Total Cost',
  COST_DETAILS: 'Cost Details',
  COST_TO_SEND_SMS_PER_USER: 'Cost to Send SMS per user',
  CANCEL: 'Cancel',
  SEND: 'Send',
  SEND_EMAIL: 'Send Email',
  GUEST_TIPPING_INFO: 'This is used for CC validation. Your tip will be anonymous and your name will not show on the tip or be recorded.',
  SEND_SMS: 'Send Text Message',
  PUSH_NOTIFICATION: 'Push Notification',
  SEND_PUSH_NOTIFICATION: 'Send Push Notification',
  USER: 'User',
  MESSAGE_COST_LABEL: 'You will be charged',
  UNLOCK_MESSAGE_LABEL: 'to unlock the message from',
  PAID_DIRECT_MESSAGE: "'s paid Direct Message.",
  SEND_MESSAGE_LABEL: 'to send the direct message to',
  USERS_MESSAGE_LABEL: 'to',
  USERS_COUNT_LABEL: 'users.',
  EMAIL: 'Email',
  AN_EMAIL: 'an Email',
  TEXT_MESSAGE: 'Text Message',
  A_TEXT_MESSAGE: 'a SMS Text Message',
  ONE_USER_ACTIVE_WITH_VALID_PHONE:
    'Note: There is 1 user with valid phone number and has consented to receiving SMS messages.',
  N_USER_ACTIVE_WITH_VALID_PHONE:
    'Note: There are [count] users in your specified segment, with a valid mobile phone number and have consented to receiving SMS messages.',
  SMS_TOTAL_COST_CALCULATION_INFO:
    "The Total Cost to send SMS messages is based on 3rd party SMS fees and dynamically calculated based on any respective international fees per each fan's mobile number.",
  ONE_USER_ACTIVE_WITH_VALID_EMAIL: 'Note: There is 1 user with valid email and has consented to receiving email messages.',
  N_USER_ACTIVE_WITH_VALID_EMAIL:
    'Note: There are [count] users in your specified segment, with a valid email and have consented to receiving email messages.',
  DOWNLOAD_CSV: 'Download CSV',
  LOAD_MORE: 'Load More',
  EXPORT_FANS: 'Export Fans',
  PLEASE_SELECT_A_CSV: 'Please select a CSV file to import.',
  PLEASE_UPLOAD_VALID_CSV: 'Please upload a valid CSV file.',
  IMPORT_FANS: 'Import Fans',
  SOMETHING_WENT_WRONG: 'Something went wrong.',
  DIRECT_MESSAGE: 'Direct Message',
  BIRTHDATE: 'Birthdate',
  EMAIL_ADDRESS: 'Email Address',
  PHONE: 'Mobile Phone Number',
  GENERAL_LOCATION: 'General Location',
  SHIPPING_ADDRESS: 'Shipping Address',
  SUPPORT_RANK: 'Lifetime Spend',
  ENGAGEMENT_RANK: 'Lifetime Engagement',
  RECRUITMENT_RANK: 'Lifetime Fan Recruitment',
  HISTORY: 'History',
  APPLY: 'Apply',
  NO: 'No',
  FOUND: 'Found',
  ENGAGEMENTS: 'Engagement',
  ENGAGEMENTS_PLURAL: 'Engagements',
  RECRUITMENT: 'Recruitment',
  RECRUITMENTS: 'Recruitments',
  SEARCH_BY_NAME: 'Search By Name',
  SELECT:'Select',
  FROM_DATE: 'From Date',
  TO_DATE: 'To Date',
  ACTIVE_SUBSCRIBERS: 'Subscribers',
  NEWSLETTERS: 'newsletters',
  SUBSCRIPTIONS: 'subscriptions',
  INSIGHTS_FANS: 'INSIGHTS & FANS', 
  NO_SAVED_SEGMENTS: 'No Saved Segments', 
  SAVE_SEGMENT_SETTINGS: 'Save This Segment',
  CREATE_SEGMENT: 'Create Segment',
  POST_ENGAGEMENT_TRENDS :'Post Engagement Trends',
  LAST_SESSION: 'Last Session',
  REGISTER_DATE: 'Registration Date',
  FAN_STATUS: 'Fan Status',
  SUBSCRIBERS: 'Subscriber',
  COMP_SUBSCRIPTION: 'Comp Subscription',
  NEWSLETTER_RECIPIENTS: 'Newsletter Recipient',
  FAN_MANAGEMENT_DOWNLOAD_LABEL: `You will receive a CSV file of your current fans who have consented to sharing their information with you.`,
  DOWNLOAD_CSV_LIST_OF_SEGMENTED_FANS: `Download CSV List Of Segmented Fans`,
  NA: '#NA',
  TRANSACTION_HISTORY: 'Transaction History',
  NO_FANS_FOUND: 'No Matching Fans Found. Please Adjust Date Range.',
  NO_ALL_FAN_FOUND: 'No Matching Fans Found',
  FAN_STATUS_MESSAGE: `<p class="fan-status-message-item"><em class="icon-litefollower-icon"></em> <span>Followers</span></p> <p class="fan-status-message-item"><em class="icon-subsribe"></em> <span>Subscribers</span></p> <p class="fan-status-message-item"><em class="icon-litenewsletterIcon"></em> <span>Newsletter Recipients</span></p> <p class="fan-status-message-item"><em class="icon-liteAccountant"></em> <span>Purchasers</span></p> <p class="fan-status-message-item"><em class="icon-liteengager"></em> <span>Content Engagers</span></p> <p class="fan-status-message-item"><em class="icon-litecomplimentry-gift"></em> <span>Imported with Subscriptions</span></p> <p class="fan-status-message-item"><em class="icon-liteunregister"></em> <span>Imported & Unregistered</span></p>`,
  SEGMENT_FAN_STATUS_MESSAGE: `<p class="fan-status-message-item"><em class="icon-litefollower-icon"></em> <span>Followers</span></p> <p class="fan-status-message-item"><em class="icon-subsribe"></em> <span>Subscribers</span></p> <p class="fan-status-message-item"><em class="icon-litenewsletterIcon"></em> <span>Newsletter Recipients</span></p> <p class="fan-status-message-item"><em class="icon-liteAccountant"></em> <span>Purchasers</span></p> <p class="fan-status-message-item"><em class="icon-liteengager"></em> <span>Content Engagers</span></p> <p class="fan-status-message-item"><em class="icon-liteunregister"></em> <span>Imported & Unregistered</span></p>`,
  SEGMENT_LIST_HINT: `This list of fans represents those who match the segmentation filter criteria you specified above. To see your full list of fans remove any filtering criteria.`,
  FAN_IMPORT_COMPLETE: 'Fan Import Complete',
  SEND_INVITE_TO_FAN: 'Send Invite to Imported Fans',
  PREVIEW: 'Email Invite Preview',
  EMAIL_PREVIEW: 'Email Preview',
  RANKED: 'Ranked',
  FOLLOWER: 'Follower',
  RESEND_INVITE  :'Resend Invite',
  SEND_INVITE: 'Send Invite',
  RESEND_INVITE_TO_ALL: 'Resend Invite to All',
  RESEND_INVITE_TO_SELECTED: 'Resend Invite to Selected',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  PHONE_NUMBER: 'Phone Number',
  FILTER_BY: 'FILTER BY',
  SELECT_DATE: 'Select Date',
  FILTER_BY_HEADER: 'Filter By',
  OVERVIEW: 'OVERVIEW',
  VIEW_LESS: 'VIEW LESS',
  VIEW_ALL: 'VIEW ALL',
  POLLING_SKIP: 'Polling skipped due to inactive tab',
  SEND_ALL_UNREGISTERED: 'SEND_ALL_UNREGISTERED',
  ERROR_IN_PROGRESS: 'Please wait, We are progressing your import',
  IMPORTING_FANS: 'Importing Fans',
  IMPORT_COMPLETED: 'Import Completed',
  LAST_ACTIVITY_DATE: 'Last Content Engagement',
  FAN_SESSIONS: 'Subscriptions',
  NO_FAN_SESSIONS_FOUND: 'No Subscription Found',
  LOADING_FAN_SESSIONS: 'Loading subscriptions...',
  VIEW_FAN_SESSIONS: 'View Details',
  NOT_SUBSCRIBED: 'Not Subscribed',
  GRANT_COMP_PLAN: 'Grant Comp Plan',
  GRANT_COMPLIMENTARY_SUBSCRIPTION: 'Grant Complimentary Subscription',
  COMPLIMENTARY_PLAN_AND_DURATION: 'Complimentary Plan and Duration',
  SELECT_PLAN: 'Select Plan',
  DURATION_MONTHS: 'Duration (Months)',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  GRANT: 'Grant',
  COMPLIMENTARY: 'COMPLIMENTARY',
  ACTION: 'ACTION',
  NO_ENGAGEMENT_FOUND: 'No Engagement data available for this period.',
  YES: 'Yes',
  MONTHS: ' Months',
  MONTH: ' Month',
  TOTAL_PLAYS: 'Total Plays',
  TOTAL_TIME_PLAYED: 'Total Time Played',
  TOTAL_REVENUE: 'Total Revenue',
  PORTFOLIO_TOTAL_PERFORMANCE: 'Portfolio Total Performance',
  SEARCH_SONG_OR_ALBUM: 'Search song or album',
  ALL_SONGS: 'ALL SONGS',
  ALBUMS: 'ALBUMS',
  ALL_ITEMS: 'All Items',
  SINGLE_ITEM: 'SINGLE ITEM',
  SONG_NAME: 'Song Name',
  ALBUM_NAME: 'Album Name',
  PUBLISHED_DATE: 'Published Date',
  IMPRESSIONS: 'Impressions',
  PLAYS: 'Plays',
  PURCHASES: 'Purchases',
  REVENUE: 'Revenue',
  ITEMS: 'Items',
  REGISTER_INFO: "This is when the user most recently logged into TopFan or the Creator's White Label Site",
  ACTIVITY_INFO: "This is when the user most recently engaged with the Creator’s content (i.e.,  viewed the details of a post, liked, commented, shared)",
  FAN_SEGMENTATION_CSV: 'Segmented_Fans.csv',
  FAN_NOTES: 'Fan Notes',
  BADGES: 'Badges',
  GROUPS: 'Groups',
  EDIT_GROUPS: 'Edit Groups For',
  GROUP_NAME: 'Group Name',
  GROUP_STATUS: 'Status',
  YOU_MUST_HAVE_AT_LEAST_ONE_ACTIVE_GROUP: 'To assign groups to fans, you must have at least one active group in Preferences > Groups',
  GO_TO_GROUPS: 'Go To Groups Preferences',
  GROUPS_PREFERENCES: 'Groups Preferences',
  LOYALTY_POINTS: 'Loyalty Points',
  EDIT_BADGES: 'Edit Badges For',
  BADGE_NAME: 'Badge Name',
  POINTS: 'Points',
  YOU_MUST_HAVE_AT_LEAST_ONE_ACTIVE_BADGE: 'To assign badges to fans, you must have at least one active badge in Preferences > Fan Badges',
  GO_TO_BADGES: 'Go To Badges Preferences',
  BADGES_PREFERENCES: 'Badges Preferences',
  EDIT_IN_PREFERENCES: 'Edit In Preferences',
  SAVE: 'Save',
  EDIT_FAN_NOTES: 'Edit Fan Notes',
  DELETE_IMPORTED_UNREGISTERED_FAN: 'Delete Imported & Unregistered Fan',
  DELETE_FAN_CONFIRMATION_MESSAGE: 'Are you sure you want to delete this fan? This action cannot be undone.',
  SEGMENTATION_AND_OUTREACH: 'Segmentation & Outreach',
  STORE_AND_SUBSCRIPTION_PURCHASES: 'Store & Subscription Purchases',
  PURCHASED: 'Purchased',
  NOT_PURCHASED: 'Not Purchased',
  CONTENT: 'Content',
  TOPIC_TAGS: 'Topic Tags',
  TOPIC_TAG_ENGAGEMENTS: 'Topic Tag Engagement',
  ENGAGED: 'Engaged',
  NOT_ENGAGED: 'Not Engaged',
  JOIN_PLACEHOLDER_COMMUNITY: 'Join [CREATOR_NAME]\'s Community',
  DOWNLOAD_CSV_LIST_OF_FANS: `Download CSV List Of Fans`,
  FAN_SEGMENTATION_DOWNLOAD_LABEL: `You will receive a CSV file of your current fans who match the segmentation filters and who have consented to sharing their information with you.`,
  DATA_CONTROLLER_DISCLAIMER: `Note: In accordance with TopFan's Terms of Service, by exporting this data you will be considered a Data Controller and must comply with specific privacy and security responsibilities as defined by local and international laws, including but not limited to GDPR and CCPA.`,
  IMPORTED: 'Imported',
  NOT_SHARED: 'Not Shared',
  NOT_AVAILABLE: 'Not Available',
  CUSTOM: 'Custom',
  CONTENT_TYPE_ALL: 'All Portfolios',
  FAILED_TO_LOAD_DATA: 'Failed to load data. Please try again.',
  NO_PORTFOLIO_ITEMS: 'No data to display.',
  MUSIC: 'Music',
  PODCAST: 'Podcast',
  VIDEO: 'Video',
  CREATE_NEW_FAN_SEGMENT: 'Create a New Fan Segment',
  CREATE_SEGMENT_HINT: 'Create a Segment of Your Fans by Using the Filters Below. Once You Click Create Segment You Will be Given Outreach Options to Email, SMS, DM and Export That Fan Segment.\n\n<b>Note:</b> If You Don\'t Change Any Filter, All Fans in Your Fan Database Will be Returned in the Segment.',
};
export const MESSAGE_TYPE = {
  SMS: 'sms',
  EMAIL: 'email',
  PUSH_NOTIFICATION: 'push_notification'
};

export const PAYMENT_METHOD = {
  WALLET: 'WALLET',
  CARD: 'CARD'
} as const;

export const SegmentationPaymentMessages = {
  TOTAL_AMOUNT_DUE: 'Total Amount Due',
  USE_WALLET: 'Use Wallet',
  REMAINING_WALLET_BALANCE: 'Remaining wallet balance:',
  USE_CREDIT_CARD: 'Use Credit Card',
  SAVED_CREDIT_CARD: 'Saved Credit Card',
  EXP_DATE: 'Exp Date',
  EXPIRED: 'EXPIRED',
  NO_SAVED_CARD: 'NO SAVED CARD',
  NO_SAVED_CARD_MESSAGE: "It looks like you haven't linked a credit card to your account yet. Please add one so you can continue with the payment.",
  ADD_CARD: '+ ADD CARD',
  CREDIT_DEBIT_CARD_INFO: 'Credit/Debit Card Info',
  PAY_NOW: 'PAY NOW',
  ORDER_DETAILS: 'ORDER DETAILS',
  TOTAL_COST: 'Total Cost',
  USERS: 'Users',
  CC_SURCHARGE: '3rd Party CC Surcharge',
  CC_SURCHARGE_INFO: 'If you use your Wallet to pay, you can avoid the 3rd Party Credit Card Surcharge.',
  CC_SURCHARGE_BREAKDOWN: '2.9% + $0.30',
  CC_SURCHARGE_BREAKDOWN_INTERNATIONAL: '4.4% + $0.30',
  TOTAL_AMOUNT: 'Total Amount',
  ADD_CARD_ERROR: 'Please add a credit card to continue',
  CARD_EXPIRED_ERROR: 'Your saved card has expired. Please add a new card.',
  MESSAGE_SENT_SUCCESSFULLY: 'Message sent successfully',
  PAYMENT_SUCCESSFUL_EMAIL: 'Email sent successfully to [COUNT] Fans.',
  PAYMENT_SUCCESSFUL_SMS: 'SMS sent successfully to [COUNT] Fans.',
  PAYMENT_SUCCESSFUL_PUSH_NOTIFICATION: 'Push notification sent successfully to [COUNT] Fans.',
  EMAIL_LABEL: 'Email',
  SMS_LABEL: 'SMS',
  EMAIL_LOWER: 'email',
  SMS_LOWER: 'SMS',
  EMAILS_PLURAL: 'emails',
  USERS_LOWER: 'users',
  COST_BREAKDOWN: '$[COST] × [COUNT] [USERS]',
  INFO_BOX_TITLE: 'Send [TYPE] to [COUNT] Users',
  INFO_BOX_MESSAGE:
    'Your [TYPE] will be sent to the [COUNT] fans from your segmentation who have consented to receiving [TYPE_PLURAL] from you.'
} as const;
export const PK_CONSTANT = {
  USER: 'USER#',
  EXPERIENCE: 'EXPERIENCE#'
};
export const INSIGHT_TAB = {
  USER: 'user',
  ENGAGEMENT: 'engagement',
  FAN_RELATIONSHIP_MANAGEMENT: 'FAN_RELATIONSHIP_MANAGEMENT',
  FAN_MANAGEMENT : 'FAN_MANAGEMENT',
  FAN_SEGMENT: 'FAN_SEGMENT',
  EARNING: 'earning',
  ALL: 'all',
  TOP_SUPPORTER: 'top-supporters'
};
export const typeFilterField =  {
  type: fieldTypes.SELECT,
  label: '',
  name: 'filter',
  class: 'col-12',
  placeholder: 'Select Date',
  options: [
    { label: 'Today', value: 'today' },
    { label: 'This Week', value: 'this-week' },
    { label: 'Last Week', value: 'last-week' },
    { label: 'This Month', value: 'this-month' },
    { label: 'Last Month', value: 'last-month' },
    { label: 'All Time', value: 'all-time'},
    { label: 'Custom Dates', value: 'custom-range' }
  ],
  labelKey: 'label',
  valueKey: 'value'
};

export const chartFilterField =  {
  type: fieldTypes.SELECT,
  label: '',
  name: 'filter',
  class: 'col-12',
  placeholder: 'Status Type',
  options: [
    { label: 'Website Visit', value: 'website-visit' },
    { label: 'DM : sent & received', value: 'direct-message' }
  ],
  labelKey: 'label',
  valueKey: 'value'
};

export const portfolioMetricFilterField =  {
  type: fieldTypes.SELECT,
  label: '',
  name: 'chartMetric',
  class: 'col-12',
  placeholder: Messages.REVENUE,
  options: [
    { label: Messages.REVENUE, value: 'revenue' },
    { label: Messages.ENGAGEMENTS, value: 'engagement' }
  ],
  labelKey: 'label',
  valueKey: 'value'
};

export const portfolioItemsFilterField =  {
  type: fieldTypes.SELECT,
  label: '',
  name: 'chartItemType',
  class: 'col-12',
  placeholder: Messages.CONTENT_TYPE_ALL,
  options: [
    { label: Messages.CONTENT_TYPE_ALL, value: 'all' },
    { label: Messages.MUSIC, value: 'music' },
    { label: Messages.PODCAST, value: 'podcast' },
    { label: Messages.VIDEO, value: 'video' },
    { label: Messages.CUSTOM, value: 'custom' }
  ],
  labelKey: 'label',
  valueKey: 'value'
};

export const SONGS_TABLE_HEADERS = [
  {
    keyGroup: {
      src: 'cover_image',
      firstName: 'first_name',
      lastName: 'last_name'
    },
    label: Messages.SONG_NAME,
    width: 'w-30 w-m-100',
    type: TableHeaderTypes.AVTARIMAGETEXT
  },
  {
    key: 'album_name',
    label: Messages.ALBUM_NAME,
    width: 'w-20 w-m-100'
  },
  {
    key: 'published_date',
    label: Messages.PUBLISHED_DATE,
    width: 'w-20 w-m-100',
    type: TableHeaderTypes.DATE,
    showSortIcons: true
  },
  {
    key: 'plays',
    label: Messages.PLAYS,
    defaultValue: Application.ZERO,
    width: 'w-15 w-m-100',
    showSortIcons: true
  },
  {
    key: 'revenue',
    label: Messages.REVENUE,
    width: 'w-15 w-m-100',
    type: TableHeaderTypes.CURRENCY,
    showSortIcons: true
  }
];

export const ALBUMS_TABLE_HEADERS = [
  {
    keyGroup: {
      src: 'cover_image',
      firstName: 'first_name',
      lastName: 'last_name'
    },
    label: Messages.SONG_NAME,
    width: 'w-30 w-m-100',
    type: TableHeaderTypes.AVTARIMAGETEXT
  },
  {
    key: 'published_date',
    label: Messages.PUBLISHED_DATE,
    width: 'w-20 w-m-100',
    type: TableHeaderTypes.DATE,
    showSortIcons: true
  },
  {
    key: 'items_count',
    label: Messages.ITEMS,
    width: 'w-20 w-m-100'
  },
  {
    key: 'plays',
    label: Messages.PLAYS,
    width: 'w-15 w-m-100',
    defaultValue: Application.ZERO,
    showSortIcons: true
  },
  {
    key: 'revenue',
    label: Messages.REVENUE,
    width: 'w-15 w-m-100',
    type: TableHeaderTypes.CURRENCY,
    showSortIcons: true
  }
];

export const VIEW_LABELS: { [key: string]: string } = {
  newsletters: 'View Recipients',
  subscriptions: 'View Subscribers',
};

export const CHART_LEGEND = {
  content_views: 'TopFan',
  content_views_in_wls: 'White Label Site'
}

export const CHART_RENDER_RETRY_DELAY = 200;
export const FAN_MANAGEMENT_KEY_LABEL = {
  all: 'all',
  top_supporters: 'top-supporters',
  most_engaged: 'most-engaged',
  top_recruiters: 'top-recruiters',
  purchase: 'purchase',
  engagement: 'engagement',
  recruitment: 'recruitment',
  IN_PROGRESS: 'IN_PROGRESS'
}

export const ENGAGEMENT_TYPE_MAPPING = {
  ALBUM: 'ALBUM',
  MUSIC: 'MUSIC',
  ALBUM_MUSIC: 'ALBUM_MUSIC',
  MUSIC_PORTFOLIO: 'Music Portfolio',
  ALBUM_PODCAST: 'ALBUM_PODCAST',
  PODCAST: 'PODCAST',
  PLAY: 'Play',
  WATCH: 'Watch',
  PODCAST_PORTFOLIO: 'Podcast Portfolio',
  VIDEO_PORTFOLIO: 'Video Portfolio',
  VIDEO: 'VIDEO',
  ALBUM_VIDEO: 'ALBUM_VIDEO',
}

export const PORTFOLIO_TYPE_CONFIG = [
  {
    types: [
      ENGAGEMENT_TYPE_MAPPING.ALBUM,
      ENGAGEMENT_TYPE_MAPPING.ALBUM_MUSIC,
      ENGAGEMENT_TYPE_MAPPING.MUSIC
    ],
    postType: ENGAGEMENT_TYPE_MAPPING.MUSIC_PORTFOLIO,
    actionType: ENGAGEMENT_TYPE_MAPPING.PLAY
  },
  {
    types: [
      ENGAGEMENT_TYPE_MAPPING.PODCAST,
      ENGAGEMENT_TYPE_MAPPING.ALBUM_PODCAST
    ],
    postType: ENGAGEMENT_TYPE_MAPPING.PODCAST_PORTFOLIO,
    actionType: ENGAGEMENT_TYPE_MAPPING.PLAY
  },
  {
    types: [
      ENGAGEMENT_TYPE_MAPPING.VIDEO,
      ENGAGEMENT_TYPE_MAPPING.ALBUM_VIDEO
    ],
    postType: ENGAGEMENT_TYPE_MAPPING.VIDEO_PORTFOLIO,
    actionType: ENGAGEMENT_TYPE_MAPPING.WATCH
  }
];

export const RELATIONSHIP_CONST = {
  'all': {label: 'All Fans', icon: 'icon-litegroup_icon'},
  'top-supporters': {label:'Top Supporters', icon: 'icon-litetop-arrow'},
  'most-engaged': {label:'Most Engaged', icon: 'icon-litestar-icon'},
  'top-recruiters': {label:'Top Recruiters', icon: 'icon-liteengagement'},
}

export const DETAILS_TAB_KEYS = {
  'purchase':{label: 'Purchase History', icon: 'icon-litetransaction-not-found', notFoundMsg: 'User Has Not Made Any Purchases Yet'},
  'engagement': {label: 'Engagement', icon: 'icon-litestar-icon', notFoundMsg: 'User Has Not Engaged With Any Content Yet'},
  'recruitment': {label: 'Fan Recruitment', icon: 'icon-liteengagement', notFoundMsg: 'User Has Not Recruited Any Other Fans Yet'},
}
export const tabs = [
    { label: 'ALL FANS', key: FAN_MANAGEMENT_KEY_LABEL.all, heading: 'All Fans', iconClass: 'icon-litegroup_icon' },
    { label: 'TOP SUPPORTERS', key: FAN_MANAGEMENT_KEY_LABEL.top_supporters, heading: 'Top Supporters', iconClass: 'icon-litetop-arrow' },
    { label: 'MOST ENGAGED', key: FAN_MANAGEMENT_KEY_LABEL.most_engaged, heading: 'Most Engaged', iconClass: 'icon-litestar-icon' },
    { label: 'TOP RECRUITERS', key: FAN_MANAGEMENT_KEY_LABEL.top_recruiters, heading: 'Top Recruiters', iconClass: 'icon-liteengagement' },
];

export const MATCH_FAN_KEYS = {
  'all': 'purchase',
  'top-supporters': 'purchase',
  'most-engaged': 'engagement',
  'top-recruiters': 'recruitment',
}
export const inviteHeadingField = {
    type: fieldTypes.TEXT,
    label: 'Email Subject Line:',
    placeholder: 'Enter Email Subject here',
    name: 'title',
    class: 'col-12',
    styleClass: 'mt-2',
    validation: {
        required: {
          message: 'Please include an Email Subject Line'
        },
        minlength: {
          value: 10,
          message: 'Title should be minimum 10 characters'
        },
        maxlength: {
          value: 100,
          message: 'Title Should be less than 100 characters'
        },
    }
}

export const USER_ACTIONS = {
  ALL: 'all',
  FOLLOWERS: "followers",
  SUBSCRIBERS: "subscribers",
  NEWSLETTER_RECIPIENTS: "newsletter_recipients",
  REGISTER: "register",
  UNREGISTER: "unregister",
  PURCHASER: "purchaser",
  ENGAGER: "engager",
}

export const InviteCustomModule = {
  'toolbar': [
      ['bold', 'italic', 'underline', 'image']
   ]
}

export const localMessages = {
  MINIMUM_DESC_LENGTH_ERROR: 'Length of your Invite email must be at least 50 characters.',
  DESC_REQUIRED: '* Description is required',
  SELECT_INTERESTS: 'Select Interests',
  FEED_PREVIEW_IMAGE: 'Invite Preview Image',
  UPLOAD: 'Upload',
  CANCEL: 'Cancel',
  MAXIMUM_DESC_LENGTH_ERROR: '* Maximum character length cannot be greater than 50000.',
  ADD_FIRST_NAME: '+ Insert First Name',
  SEND_INVITE_TO: 'Send Invite to',
  FANS: 'Fans'
};

export const ALL_FAN_FILTER_FIELDS = { 
  sections: 
    [ 
      {
        title: '',
        fields: [
          {
            type: fieldTypes.SELECT,
            label: '',
            name: 'all-fan-select',
            placeholder: 'Select',
            class: 'col-lg-6 col-12',
            labelKey: 'label',
            valueKey: 'value',
            iconClass: 'iconClass',
            options: [
                { label: 'Filter By Status', name:USER_ACTIONS.ALL, value: USER_ACTIONS.ALL, iconClass: ""},
                { label: 'Followers', name: USER_ACTIONS.FOLLOWERS, value: USER_ACTIONS.FOLLOWERS, iconClass: "icon-litefollower-icon"},
                { label: 'Subscribers', name: USER_ACTIONS.SUBSCRIBERS,value: USER_ACTIONS.SUBSCRIBERS, iconClass: "icon-subsribe"},
                { label: 'Newsletter Recipients',name: USER_ACTIONS.NEWSLETTER_RECIPIENTS, value: USER_ACTIONS.NEWSLETTER_RECIPIENTS, iconClass: "icon-litenewsletterIcon"},
                { label: 'Purchasers', name: USER_ACTIONS.PURCHASER, value: USER_ACTIONS.PURCHASER, iconClass: "icon-liteAccountant"},
                { label: 'Content Engagers', name: USER_ACTIONS.ENGAGER, value: USER_ACTIONS.ENGAGER, iconClass: "icon-liteengager"},
                { label: 'Imported & Unregistered', name: USER_ACTIONS.UNREGISTER, value: USER_ACTIONS.UNREGISTER, iconClass: "icon-liteunregister"},
              ],
          },
        ] 
      }
    ]
}

export const UNREGISTER_TABLE = [
  {
    key: 'name',
    label: 'NAME',
    width: 'w-20 w-m-100',
    showSortIcons: true,
  },
  {
    key: 'phone_no',
    label: 'PHONE',
    width: 'w-20 w-m-100',
  },
  {
    key: 'email',
    label: 'EMAIL ADDRESS',
    width: 'w-25 w-m-100 text-align-left',
    showToolTip: true,
  },
  { key: '', label: 'Resend Invite to Selected', width: 'w-30 w-m-100', isButton: true, btnClass: 'btn btn-primary' }
];

export const DEFAULT_INVITE_DESCRIPTION = `Hi [FirstName],<br><br>I'm trilled to invite you to become part of a private community for my best fans.<br><br>By joining, you gain access to my newest and most exclusive content before anyone else. This includes livestreams, videos, photo galleries, courses, direct messaging, and merchandise drops.<br><br>Click the link below and when you arrive at my website, please select &quot;Create New Account&quot;.<br><br>Looking forward to getting to know you and I sincerely appreciate all your support!<br><br>[CreatorName]`;

export const DEFAULT_SEGMENTATION_EMAIL_DESCRIPTION = `Hi [FirstName],<br><br>Replace with your personal email message to your fans.<br><br>[CreatorName]`;

export const DATE_FILTER_OPTIONS = [
  { label: 'Today', value: WEEK_LABELS.TODAY },
  { label: 'This Week', value: WEEK_LABELS.THIS_WEEK },
  { label: 'Last Week', value: WEEK_LABELS.LAST_WEEK },
  { label: 'This Month', value: WEEK_LABELS.THIS_MONTH },
  { label: 'Last Month', value: WEEK_LABELS.LAST_MONTH },
  { label: 'All Time', value: WEEK_LABELS.ALL_TIME},
  { label: 'Custom Dates', value: WEEK_LABELS.CUSTOM_DATES }
];

export const IMPORT_USER_STATUS = {
  FAILED: "FAILED",
  ALREADY_EXIST: "ALREADY_EXIST",
  IMPORTED: "IMPORTED"
};

export const IMPORT_STATUS = {
  COMPLETED: 'COMPLETED',
  AVAILABLE: 'AVAILABLE',
  IN_PROGRESS: 'IN_PROGRESS'
}
export const INSIGHT_MAIN_TAB_KEY = {
  earning: 'earning',
  engagement: 'engagement',
  portfolios: 'portfolios',
  FAN_RELATIONSHIP_MANAGEMENT: 'fan-relationship-management',
}

export const FAN_DETAILS_HEADER =  [
  { key: 'name', label: 'PLAN', width: 'w-25 w-m-100', chip: 'complementary_chip', chipIconClass: 'icon-litecomplimentry-gift' },
  { key: 'duration_month', label: 'DURATION', width: 'w-25 w-m-100' },
  { key: 'start_date', label: 'START DATE', width: 'w-25 w-m-100', type: TableHeaderTypes.DATE },
  { key: 'expired_date', label: 'END DATE', width: 'w-25 w-m-100', type: TableHeaderTypes.DATE },
  { key: 'auto_renewal', label: 'AUTO-RENEWAL', width: 'w-25 w-m-100' }
];

export const EDIT_FAN_NOTES_FIELDS = {
  sections: [
    {
      title: '',
      fields: [
        {
          type: fieldTypes.TEXT_AREA,
          label: 'Fan Notes',
          name: 'notes',
          class: 'col-12',
          placeholder: 'Enter fan notes...',
          maxlength: 200,
          validation: {
            required: {
              message: 'Notes are required'
            },
            maxlength: {
              value: 200,
              message: 'Notes should be less than 200 characters'
            }
          }
        }
      ]
    }
  ],
};

export const GRANT_COMPLEMENTARY_CTA_BTN = {
  type: 'button',
  label: Messages.GRANT_COMPLIMENTARY_SUBSCRIPTION,
  class: 'btn btn-primary',
  emClass: 'icon-newpost-plus me-2'
};

export const GRANT_COMPLEMENTARY_CANCEL_BTN = {
  type: 'button',
  label: Messages.CANCEL,
  class: 'btn',
  name: 'cancelGrant'
};

export const GRANT_COMPLEMENTARY_SUBMIT_BTN = {
  type: 'button',
  label: Messages.GRANT,
  class: 'btn btn-primary',
  name: 'grantComplementary'
} as const;

export const getGrantComplementaryFields = (
  durationOptions: { id: string; duration: number; label: string }[],
  planOptions: any[] = []
) => ({
  sections: [
    {
      title: '',
      fields: [
        {
          type: fieldTypes.SELECT,
          label: 'Select Plan',
          name: 'plan_id',
          placeholder: 'Select',
          class: 'col-12 col-md-6',
          options: planOptions,
          labelKey: 'name',
          valueKey: 'sk',
          emptyOptionMessage: 'No active subscription found.',
          validation: { required: { message: 'Plan is required' } }
        },
        {
          type: fieldTypes.SELECT,
          label: 'Duration (Months)',
          name: 'sub_plan_id',
          placeholder: 'Select',
          class: 'col-12 col-md-6',
          options: durationOptions,
          labelKey: 'label',
          valueKey: 'id',
          emptyOptionMessage: 'Select a plan first.',
          validation: { required: { message: 'Duration is required' } }
        },
        {
          type: fieldTypes.DATE_PICKER,
          label: 'Start Date',
          name: 'start_date',
          placeholder: 'Select Date',
          class: 'col-12 col-md-6 start-date-picker',
          minDate: getCurrentDate(),
          validation: {
            required: { message: 'Start date is required' },
            dateRange: {
              minDate: getCurrentDate(),
              message: 'Start date must be today or a future date'
            }
          }
        },
        {
          type: fieldTypes.TEXT,
          label: 'End Date',
          name: 'end_date',
          placeholder: '',
          class: 'col-12 col-md-6',
          disabled: true
        }
      ]
    }
  ]
});

export const TIME_SINCE_ENGAGED_OPTIONS = [
  { label: '1 Day', value: 1 },
  { label: '1 Week', value: 7 },
  { label: '1 Month', value: 30 },
  { label: '3 Months', value: 90 },
  { label: '6 Months', value: 180 },
  { label: '1 Year+', value: Number.MAX_SAFE_INTEGER }
];

export const ENGAGEMENT_COUNT_OPTIONS = [
  { label: '0-99', value: '0-99', min: 0, max: 99 },
  { label: '100-249', value: '100-249', min: 100, max: 249 },
  { label: '250-499', value: '250-499', min: 250, max: 499 },
  { label: '500-999', value: '500-999', min: 500, max: 999 },
  { label: '1000-4999', value: '1000-4999', min: 1000, max: 4999 },
  { label: '5000+', value: '5000+', min: 5000, max: Number.MAX_SAFE_INTEGER }
];

export const GENERAL_ACTIVITY_FIELDS = {
  sections: [
    {
      title: '',
      fields: [
        {
          type: fieldTypes.SELECT,
          label: 'Fan Status',
          name: 'all-fan-select',
          placeholder: 'Select',
          class: 'col-12 col-lg-4',
          labelKey: 'label',
          valueKey: 'value',
          iconClass: 'iconClass',
          options: [
              { label: 'Filter By Status', name:USER_ACTIONS.ALL, value: USER_ACTIONS.ALL, iconClass: ""},
              { label: 'Followers', name: USER_ACTIONS.FOLLOWERS, value: USER_ACTIONS.FOLLOWERS, iconClass: "icon-litefollower-icon"},
              { label: 'Subscribers', name: USER_ACTIONS.SUBSCRIBERS,value: USER_ACTIONS.SUBSCRIBERS, iconClass: "icon-subsribe"},
              { label: 'Newsletter Recipients',name: USER_ACTIONS.NEWSLETTER_RECIPIENTS, value: USER_ACTIONS.NEWSLETTER_RECIPIENTS, iconClass: "icon-litenewsletterIcon"},
              { label: 'Purchasers', name: USER_ACTIONS.PURCHASER, value: USER_ACTIONS.PURCHASER, iconClass: "icon-liteAccountant"},
              { label: 'Content Engagers', name: USER_ACTIONS.ENGAGER, value: USER_ACTIONS.ENGAGER, iconClass: "icon-liteengager"},
              { label: 'Imported & Unregistered', name: USER_ACTIONS.UNREGISTER, value: USER_ACTIONS.UNREGISTER, iconClass: "icon-liteunregister"},
            ],
        },
        {
          type: fieldTypes.NUMBER,
          label: 'Lifetime Min Spend',
          name: 'lifetime_min_spend',
          placeholder: 'Min Spend',
          class: 'col-12 col-lg-4'
        },
        {
          type: fieldTypes.NUMBER,
          label: 'Lifetime Max Spend',
          name: 'lifetime_max_spend',
          placeholder: 'Max Spend',
          class: 'col-12 col-lg-4'
        },
        {
          type: fieldTypes.SELECT,
          label: 'Time Since Last Engagement',
          name: 'time_since_last_engaged',
          placeholder: 'Select a Time Period',
          class: 'col-12 col-lg-6',
          labelKey: 'label',
          valueKey: 'value',
          options: TIME_SINCE_ENGAGED_OPTIONS
        },
        {
          type: fieldTypes.SELECT,
          label: 'Number of Content Engagements',
          name: 'content_engagement_range',
          placeholder: 'Select a Range',
          class: 'col-12 col-lg-6',
          labelKey: 'label',
          valueKey: 'value',
          options: ENGAGEMENT_COUNT_OPTIONS
        }
      ]
    }
  ]
};

export const EARNING_ANALYTICS_FILTERS = {
  PORTFOLIO_EARNING_ANALYTICS: "PORTFOLIO_EARNING_ANALYTICS"
} as const;